import {
  Dialog,
  DialogContent,
  Box,
  useTheme,
  useMediaQuery,
  DialogActions,
} from "@mui/material";
import ModalHeader from "./components/ModalHeader";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./styles/styles.scss";
import muiCustomStyles from "./styles/styles";

const GenericSwiperDialog = ({
  open,
  onClose,
  dialogTitle,
  leftContent,
  rightContent,
  showSwiper = true,
  dialogSx = {},
  dialogContentSx = {},
  dialogBoxSx = {},
  dialogContentBoxSx = {},
  showHeader = true,
  showHelpIcon = false,
  tooltipSectionsContent,
  showActions = false,
  modalActions,
  swiperRef,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const { dialogStyle, dialogBox, dialogContent, supplierFooterStyle } =
    muiCustomStyles;

  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      disableEscapeKeyDown
      maxWidth="1200px"
      fullScreen={isSmallScreen}
      fullWidth
      sx={{ ...dialogStyle, ...dialogSx }}
    >
      <Box sx={{ ...dialogBox, ...dialogBoxSx }}>
        {showHeader && (
          <ModalHeader
            dialogTitle={dialogTitle}
            onClose={onClose}
            isSmallScreen={isSmallScreen}
            showHelpIcon={showHelpIcon}
            tooltipSectionsContent={tooltipSectionsContent}
          />
        )}
        <DialogContent sx={{ ...dialogContent, ...dialogContentSx }}>
          {isSmallScreen && showSwiper ? (
            <Box sx={dialogContentBoxSx}>
              <Swiper
                modules={[Pagination]}
                pagination={{ clickable: true }}
                spaceBetween={8}
                slidesPerView={1.04}
                centeredSlides={false}
                className="generic-dialog-swiper"
                onSwiper={(swiper) => {
                  if (swiperRef) swiperRef.current = swiper;
                }}
              >
                <SwiperSlide>{leftContent}</SwiperSlide>
                <SwiperSlide>{rightContent}</SwiperSlide>
              </Swiper>
            </Box>
          ) : (
            <Box sx={{ ...dialogContent, ...dialogContentSx }}>
              {leftContent}
              {rightContent}
            </Box>
          )}
        </DialogContent>
        {showActions ? (
          <DialogActions sx={supplierFooterStyle}>{modalActions}</DialogActions>
        ) : (
          <></>
        )}
      </Box>
    </Dialog>
  );
};

export default GenericSwiperDialog;
